import { GenericAppError, Match, Switch } from '@side/pantry';
import dynamic from 'next/dynamic';
import { Suspense, useEffect, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { AgentPageLayout } from 'src/components/AgentPageLayout';
import { LoadingFallback } from 'src/components/LoadingFallback';
import { AnalyticsEvent, useTrackEvent } from '$analytics';
import { useIdentity } from '$api-clients/hooks';

const AgentAccountProfileView = dynamic(
  () =>
    import('src/views/agent-account-profile').then(
      (exported) => exported.AgentAccountProfileView,
    ),
  { ssr: false },
);

export default function AgentAccountProfilePage() {
  const { data: userinfo, isLoading, error } = useIdentity('/auth/userinfo');
  const trackEvent = useTrackEvent();

  const [shouldHideAccountSidebar, setShouldHideAccountSidebar] =
    useState(false);

  useEffect(() => {
    if (error && !shouldHideAccountSidebar) {
      setShouldHideAccountSidebar(true);
    }
  }, [error, shouldHideAccountSidebar]);

  useEffectOnce(() => {
    trackEvent(AnalyticsEvent.AccountManagement, {
      eventContainer: 'account_profile',
      eventTarget: 'account_profile',
    });
  });

  return (
    <AgentPageLayout hideSidebar={shouldHideAccountSidebar}>
      <Switch>
        <Match when={error}>
          <GenericAppError
            buttonHref="/identity/admin/"
            title="Error loading User data"
            sx={{ width: '100%' }}
          />
        </Match>
        <Match when={isLoading}>
          <LoadingFallback />
        </Match>
        <Match when={userinfo}>
          {userinfo && (
            <Suspense fallback={<LoadingFallback />}>
              <AgentAccountProfileView
                userinfo={userinfo}
                onError={() => setShouldHideAccountSidebar(true)}
              />
            </Suspense>
          )}
        </Match>
      </Switch>
    </AgentPageLayout>
  );
}
